import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import moment from 'moment-timezone';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faTrash, faSpinner, faImage, faVideo, faExclamationTriangle, faSync } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import noDataImage from "../assets/nodata.png";
import { Link, useNavigate } from 'react-router-dom';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ReactPaginate from 'react-paginate';

const ViewAllPostedPosts = () => {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [postToDeactivate, setPostToDeactivate] = useState(null);
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [deactivating, setDeactivating] = useState({});
    const [expandedPosts, setExpandedPosts] = useState({});
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [activeMedia, setActiveMedia] = useState(null);
    const [searchDate, setSearchDate] = useState('');
    const [searchEndDate, setSearchEndDate] = useState('');
    const [searchContent, setSearchContent] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const postsPerPage = 4;
    const guid = localStorage.getItem("guid");
    const UserID = localStorage.getItem("UserID");

    const styles = {
        pageCard: { border: 'none', backgroundColor: 'transparent' },
        headerBar: { borderRadius: '18px', padding: '18px 24px', backgroundColor: '#ffffff', border: '1px solid #eef0f8' },
        headerTitle: { fontSize: '22px', color: '#2e3192', fontWeight: 700, margin: 0 },
        refreshButton: { borderRadius: '999px', paddingInline: '18px', paddingBlock: '10px', fontWeight: 600 },
        gridRow: { marginTop: '24px', alignItems: 'stretch' },
        card: { borderRadius: '22px', border: '1px solid #eef0f8', padding: '24px', backgroundColor: '#ffffff', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'visible' },
        cardContent: { display: 'flex', flexDirection: 'column', gap: '20px', flexGrow: 1 },
        sectionTitle: { fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#858aad', fontWeight: 600, marginBottom: '8px' },
        scheduleHeading: { fontSize: '20px', color: '#2e3192', fontWeight: 700, marginBottom: '4px' },
        scheduleSubheading: { fontSize: '14px', color: '#6c7293', marginBottom: 0 },
        timezoneChip: { backgroundColor: '#eef0ff', color: '#2e3192', borderRadius: '999px', padding: '6px 12px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center' },
        statusBadge: { backgroundColor: '#e9f8ff', color: '#0d6efd', borderRadius: '999px', padding: '6px 14px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center', marginTop: '8px' },
        metaStack: { display: 'flex', flexDirection: 'column', gap: '8px' },
        mediaWrapper: {
            position: 'relative',
            borderRadius: '22px',
            background: 'linear-gradient(135deg, rgba(46,49,146,0.12) 0%, rgba(107,99,255,0.08) 100%)',
            padding: '18px',
            marginTop: '20px',
            overflow: 'hidden'
        },
        mediaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
        mediaBadge: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '12px',
            fontWeight: 700,
            color: '#2e3192',
            backgroundColor: '#ffffff',
            borderRadius: '999px',
            padding: '8px 14px',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            boxShadow: '0 4px 12px rgba(46,49,146,0.15)'
        },
        mediaPreviewShell: {
            borderRadius: '18px',
            backgroundColor: '#fff',
            padding: '12px',
            boxShadow: '0 8px 24px rgba(46,49,146,0.12)'
        },
        mediaPreview: {
            borderRadius: '14px',
            overflow: 'hidden',
            backgroundColor: '#0f172a',
            height: '220px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        mediaFooter: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '14px',
            color: '#4f5480',
            fontSize: '12px'
        },
        mediaFilename: { fontWeight: 600, wordBreak: 'break-all' },
        captionSection: { 
            marginTop: '16px', 
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0
        },
        captionSectionWithMedia: {
            marginTop: '16px', 
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            minHeight: 0
        },
        contentBox: { 
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            overflow: 'visible',
            display: 'block'
        },
        contentBoxWithMedia: {
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            overflow: 'visible',
            display: 'block',
            flexGrow: 1
        },
        contentBoxTruncated: {
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            overflow: 'hidden',
            position: 'relative',
            maxHeight: '250px',
            minHeight: '120px',
            height: 'auto'
        },
        contentBoxTruncatedWithMedia: {
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            overflow: 'hidden',
            position: 'relative',
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 0,
            minHeight: '200px',
            maxHeight: '650px',
            height: 'auto',
            display: 'block'
        },
        contentGradient: {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: '3rem',
            background: 'linear-gradient(0deg, rgba(248,249,255,1) 0%, rgba(248,249,255,0) 100%)'
        },
        promptBox: { backgroundColor: '#ffffff', border: '1px dashed #d9dcff', borderRadius: '18px', padding: '18px', color: '#4f5480' },
        filtersCard: { borderRadius: '18px', backgroundColor: '#f8f9ff', border: '1px solid #eef0f8', padding: '20px', marginBottom: '24px' },
        filterLabel: { fontSize: '12px', fontWeight: 600, color: '#6c7293', textTransform: 'uppercase', marginBottom: '6px' },
        filterInput: { borderRadius: '12px', border: '1px solid #d9dcff', padding: '10px 14px', fontSize: '14px', width: '100%' },
        filterActions: { display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '16px' },
        actionIconButton: { borderRadius: '12px', border: '1px solid #eef0f8', backgroundColor: '#f7f8ff', padding: '10px 12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
        actionIcon: { fontSize: '20px' },
        actionsWrapper: { display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', gap: '16px', marginTop: '16px', width: '100%' },
        toggleLink: { marginTop: '8px', fontWeight: 600, color: '#2e3192', cursor: 'pointer', border: 'none', background: 'transparent', padding: 0 },
        filterButton: { borderRadius: '999px', paddingInline: '16px', paddingBlock: '10px', fontWeight: 600 },
    };

    const ActionButton = ({ icon, label, onClick, disabled, tooltip, variant = 'outline-primary', loading = false }) => {
        const variantColor = (() => {
            switch (variant) {
                case 'success':
                    return '#28a745';
                case 'outline-danger':
                    return '#ff4d4d';
                case 'outline-dark':
                    return '#343a40';
                default:
                    return '#2e3192';
            }
        })();

        const button = (
            <button
                type="button"
                className="btn btn-icon-only"
                style={{ ...styles.actionIconButton, opacity: disabled || loading ? 0.6 : 1 }}
                onClick={onClick}
                disabled={disabled || loading}
            >
                <FontAwesomeIcon
                    icon={loading ? faSpinner : icon}
                    spin={loading}
                    style={{ ...styles.actionIcon, color: variantColor }}
                />
                <span className="visually-hidden">{label}</span>
            </button>
        );

        if (!tooltip) {
            return button;
        }

        return (
            <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-${label.replace(/\s+/g, '-').toLowerCase()}`}>{tooltip}</Tooltip>}>
                <span className="d-inline-flex">{button}</span>
            </OverlayTrigger>
        );
    };
    const resolveMediaDetails = (mediaPath = '') => {
        if (!mediaPath) return null;
        const normalized = `${mediaPath}`.trim().replace(/\\/g, '/');
        if (!normalized) return null;

        const isFullUrl = /^https?:\/\//i.test(normalized);
        const isAzureBlobUrl = normalized.includes('blob.core.windows.net');
        const isLinkedInAsset = normalized.includes('linkedin.com') || normalized.includes('media.licdn.com');

        const pathWithoutQuery = normalized.split('?')[0];
        const extension = pathWithoutQuery.split('.').pop()?.toLowerCase() || '';
        const filename = pathWithoutQuery.split(/[/\\]/).pop() || '';

        let mediaType = 'unknown';
        if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
            mediaType = 'video';
        } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension) || isLinkedInAsset) {
            mediaType = 'image';
        }

        const source = encodeURI(
            isFullUrl || isAzureBlobUrl || isLinkedInAsset
                ? normalized
                : `${process.env.REACT_APP_API_BASE_URL}/${normalized}`
        );

        return {
            source,
            mediaType,
            filename,
        };
    };

    const renderMediaPreview = (mediaDetails) => {
        if (!mediaDetails) {
            return (
                <div className="text-muted">
                    Media not available.
                </div>
            );
        }

        if (mediaDetails.mediaType === 'video') {
            return (
                <video controls style={{ width: '100%', height: '100%', maxHeight: '320px', borderRadius: '14px' }}>
                    <source src={mediaDetails.source} />
                    Your browser does not support the video tag.
                </video>
            );
        }

        if (mediaDetails.mediaType === 'image') {
            return (
                <img
                    src={mediaDetails.source}
                    alt="Post media"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            );
        }

        return (
            <div className="text-muted">
                Preview not available for this file type.
            </div>
        );
    };

    const getMediaIcon = (mediaType) => (mediaType === 'video' ? faVideo : faImage);

    const getMediaLabel = (mediaType) => {
        if (mediaType === 'video') return 'Video Attachment';
        if (mediaType === 'image') return 'Image Attachment';
        return 'Media Attachment';
    };

    const getMediaInteractionHint = (mediaType) => {
        if (mediaType === 'video') return 'Tap to play';
        if (mediaType === 'image') return 'Tap to zoom';
        return 'View media';
    };

    const getMediaFilename = (mediaDetails) => (mediaDetails ? mediaDetails.filename : '');

    const handleMediaPreviewClick = (mediaDetails) => {
        if (!mediaDetails || mediaDetails.mediaType === 'unknown') return;
        setActiveMedia(mediaDetails);
        setShowMediaModal(true);
    };

    const handleCloseMediaModal = () => {
        setShowMediaModal(false);
        setActiveMedia(null);
    };

    const renderModalMedia = () => {
        if (!activeMedia) return null;

        if (activeMedia.mediaType === 'video') {
            return (
                <video controls style={{ width: '100%', borderRadius: '12px' }}>
                    <source src={activeMedia.source} />
                    Your browser does not support the video tag.
                </video>
            );
        }

        if (activeMedia.mediaType === 'image') {
            return (
                <img
                    src={activeMedia.source}
                    alt={activeMedia.filename || 'Preview'}
                    style={{ width: '100%', borderRadius: '12px', objectFit: 'contain' }}
                />
            );
        }

        return null;
    };

    const toggleContent = (contentId) => {
        setExpandedPosts(prev => ({ ...prev, [contentId]: !prev[contentId] }));
    };

    // Function to convert URLs to clickable links
    const makeLinksClickable = (text) => {
        if (!text) return text;
        // Regular expression to match URLs (http, https, or www)
        const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
        const parts = text.split(urlRegex);
        
        return parts.map((part, index) => {
            // Check if this part matches the URL pattern
            if (/(https?:\/\/|www\.)/i.test(part)) {
                // Ensure URL has protocol
                const url = part.startsWith('http') ? part : `https://${part}`;
                return (
                    <a
                        key={index}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: '#1976d2',
                            textDecoration: 'underline',
                            wordBreak: 'break-all'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {part}
                    </a>
                );
            }
            return <span key={index}>{part}</span>;
        });
    };

   
    const fetchPosts = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallpostedpostsbyUserID/${UserID}`);
            setPosts(response.data || []);
            setError('');
        } catch (err) {
            console.error('Failed to fetch posts:', err.message);
            setError('Failed to fetch posts');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, [UserID]);
    
   
    const handleViewPost = (post) => {
        if (post.InterestsPromptID) {
            navigate(`/viewlatesttrendingpost/${post.ContentID}`);
        } else {
            navigate(`/viewPostedAigeneratedschedulepost/${post.ContentId}`);
        }
    };

    const handleViewPostComments = (LinkdinPostId) => {
        navigate(`/viewpostcomments/${LinkdinPostId}`);
    };

    // const renderMedia = (imagePath) => {
    //     if (imagePath) {
    //         const normalizedPath = imagePath.replace(/\\/g, '/');
    //         const fileExtension = normalizedPath.split('.').pop().toLowerCase();
    //         const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/${normalizedPath}`;

    //         if (['mp4', 'mov', 'avi'].includes(fileExtension)) {
    //             return (
    //                 <div className='mt-3 text-center'>
    //                     <video width="320" height="120" controls>
    //                         <source src={fileUrl} type={`video/${fileExtension}`} />
    //                         Your browser does not support the video tag.
    //                     </video>
    //                 </div>
    //             );
    //         } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
    //             return (
    //                 <div className='mt-3 text-center'>
    //                     <img src={fileUrl} alt="Post Media" height={50} width={50} />
    //                 </div>
    //             );
    //         }
    //     }
    //     return null;
    // };

    const handleDeactivateClick = (post) => {
        setPostToDeactivate(post);
        setShowDeactivateModal(true);
    };

    const handleConfirmDeactivate = async () => {
        if (!postToDeactivate) return;

        setDeactivating((prev) => ({ ...prev, [postToDeactivate.ContentId]: true }));

        try {
            const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/deactivate-post`,
                { ContentId: postToDeactivate.ContentId, Status: "REJECTED" },
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (resp.data.message === 'Post deactivated successfully') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Post deactivated successfully',
                    showConfirmButton: false,
                    timer: 3000
                });

                setPosts(posts.filter(post => post.ContentId !== postToDeactivate.ContentId));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error deactivating post!',
                    showConfirmButton: false,
                    timer: 3000
                });
            }
        } catch (err) {
            setError('Failed to deactivate post');
        } finally {
            setDeactivating((prev) => ({ ...prev, [postToDeactivate.ContentId]: false }));
            setShowDeactivateModal(false);
            setPostToDeactivate(null);
        }
    };

    const handleCloseDeactivateModal = () => {
        setShowDeactivateModal(false);
        setPostToDeactivate(null);
    };

    const resetFilters = () => {
        setSearchDate('');
        setSearchEndDate('');
        setSearchContent('');
        setCurrentPage(0);
    };

    const handleDate = (scheduledPostDate) => {
        const dateTimeString = `${scheduledPostDate?.split('T')[0]}`;
        const dateTime = moment.utc(dateTimeString);
        const date = dateTime.format('YYYY-MM-DD');
        const time = dateTime.local().format('HH:mm');
        return { date };
    };

    const handleTime = (value) => (value ? (moment.parseZone(value, moment.ISO_8601, true).isValid() ? moment.parseZone(value, moment.ISO_8601, true).format('hh:mm A') : moment(value, 'HH:mm', true).isValid() ? moment(value, 'HH:mm', true).format('hh:mm A') : value) : '');

    const filteredPosts = posts.filter(post => {
    const { date } =post.ScheduledPostDate? handleDate(post.ScheduledPostDate):handleDate(post.ScheduledDate);

       const startDateMatch = searchDate ? date >= searchDate : true;
        const endDateMatch = searchEndDate ? date <= searchEndDate : true;
        const betweenDatesMatch = searchDate && searchEndDate ? (date >= searchDate && date <= searchEndDate) : true;
        //const exactDateMatch = searchDate && !searchEndDate ? date === searchDate : true;

  return (
            (betweenDatesMatch && startDateMatch && endDateMatch) &&
    (!searchContent || post.Content.toLowerCase().includes(searchContent.toLowerCase()))
  );
});
    
    

    const pageCount = Math.ceil(filteredPosts.length / postsPerPage);
    const offset = currentPage * postsPerPage;
    const currentPosts = filteredPosts.slice(offset, offset + postsPerPage);

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <SideNavbar>
            <div className="card shadow-sm mt-3" style={styles.pageCard}>
                <div style={styles.headerBar} className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <Link
                        to={
                            localStorage.getItem('RoleID') == '4'
                                ? '/Pagehome'
                                : localStorage.getItem('RoleID') == '1'
                                    ? '/home'
                                    : '/adminhome'
                        }
                        className="text-decoration-none d-flex align-items-center gap-3"
                    >
                        <span className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ width: 40, height: 40, backgroundColor: '#eef0ff' }}>
                            <i className="fa fa-arrow-left" aria-hidden="true" style={{ color: '#2e3192' }}></i>
                        </span>
                        <h5 className="welcome-text" style={styles.headerTitle}>
                            Published Posts
                        </h5>
                    </Link>

                    <div className="d-flex flex-wrap gap-2">
                        <button className="btn btn-outline-secondary" style={styles.filterButton} onClick={resetFilters}>
                            Reset Filters
                        </button>
                        <button className="btn btn-outline-primary d-flex align-items-center gap-2" style={styles.refreshButton} onClick={fetchPosts}>
                            <FontAwesomeIcon icon={faSync} spin={loading} />
                            <span>Refresh</span>
                        </button>
                    </div>
                </div>

                <div className="container-fluid" style={{ padding: '32px 16px' }}>
                    {error && (
                        <div className="alert alert-danger d-flex align-items-center gap-2 mb-4" role="alert">
                            <FontAwesomeIcon icon={faExclamationTriangle} />
                            <span>{error}</span>
                        </div>
                    )}

                    <div style={styles.filtersCard}>
                        <div className="row g-3">
                            <div className="col-12 col-md-4">
                                <label style={styles.filterLabel}>From Date</label>
                                <input
                                    type="date"
                                    value={searchDate}
                                    onChange={(e) => { setSearchDate(e.target.value); setCurrentPage(0); }}
                                    style={styles.filterInput}
                                />
                            </div>
                            <div className="col-12 col-md-4">
                                <label style={styles.filterLabel}>To Date</label>
                                <input
                                    type="date"
                                    value={searchEndDate}
                                    onChange={(e) => { setSearchEndDate(e.target.value); setCurrentPage(0); }}
                                    style={styles.filterInput}
                                />
                            </div>
                            <div className="col-12 col-md-4">
                                <label style={styles.filterLabel}>Search Content</label>
                                <input
                                    type="text"
                                    placeholder="Enter keywords"
                                    value={searchContent}
                                    onChange={(e) => { setSearchContent(e.target.value); setCurrentPage(0); }}
                                    style={styles.filterInput}
                                />
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <div className="d-flex justify-content-center py-5">
                            <div className="spinner"></div>
                        </div>
                    ) : filteredPosts.length === 0 ? (
                        <div className="text-center py-5">
                            <img src={noDataImage} alt="No Data" style={{ width: '280px', maxWidth: '60%' }} />
                            <p style={{ color: '#2e3192', fontSize: '18px', fontWeight: 600, marginTop: '18px' }}>No published posts found</p>
                            <p className="text-muted mb-0">Try adjusting your filters or refresh the list.</p>
                        </div>
                    ) : (
                        <div className="row g-4" style={styles.gridRow}>
                            {currentPosts.map((post, index) => {
                                const { date } = post?.ScheduledPostDate ? handleDate(post?.ScheduledPostDate) : handleDate(post?.ScheduledDate);
                                const time = handleTime(post?.ScheduledTimeAsPerZone);
                                const mediaDetails = resolveMediaDetails(post.ImageURL || post.Image || post.image);
                                const statusLabel = post.Status || 'POSTED';
                                
                                // Calculate row index (2 cards per row with col-md-6)
                                const rowIndex = Math.floor(index / 2);
                                
                                // Check if any card in the same row has media
                                const rowStartIndex = rowIndex * 2;
                                const rowEndIndex = Math.min(rowStartIndex + 2, currentPosts.length);
                                const hasMediaInRow = currentPosts.slice(rowStartIndex, rowEndIndex).some(p => {
                                    const pMediaPath = p.ImageURL || p.Image || p.image;
                                    return pMediaPath;
                                });

                                return (
                                    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6" key={post.ContentId}>
                                        <div className="shadow-sm" style={styles.card}>
                                            <div style={styles.cardContent}>
                                                <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                                                    <div style={styles.metaStack}>
                                                        <span style={styles.sectionTitle}>Scheduled for</span>
                                                        <div>
                                                            <div style={styles.scheduleHeading}>{date || 'Not scheduled'}</div>
                                                            <p style={styles.scheduleSubheading}>{time || 'Time not selected'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="text-end d-flex flex-column align-items-end gap-2">
                                                        <span style={styles.timezoneChip}>{post?.TimeZone || 'Timezone pending'}</span>
                                                        <span style={styles.statusBadge}>{statusLabel}</span>
                                                    </div>
                                                </div>

                                                {mediaDetails && (
                                                    <div style={styles.mediaWrapper}>
                                                        <div style={styles.mediaHeader}>
                                                            <span style={styles.mediaBadge}>
                                                                <FontAwesomeIcon
                                                                    icon={getMediaIcon(mediaDetails.mediaType)}
                                                                    style={{ fontSize: '16px' }}
                                                                />
                                                                {getMediaLabel(mediaDetails.mediaType)}
                                                            </span>
                                                        </div>
                                                        <div style={styles.mediaPreviewShell}>
                                                            <div
                                                                style={{
                                                                    ...styles.mediaPreview,
                                                                    cursor: mediaDetails.mediaType !== 'unknown' ? 'zoom-in' : 'default'
                                                                }}
                                                                role={mediaDetails.mediaType !== 'unknown' ? 'button' : undefined}
                                                                tabIndex={mediaDetails.mediaType !== 'unknown' ? 0 : undefined}
                                                                onClick={() => handleMediaPreviewClick(mediaDetails)}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                        event.preventDefault();
                                                                        handleMediaPreviewClick(mediaDetails);
                                                                    }
                                                                }}
                                                            >
                                                                {renderMediaPreview(mediaDetails)}
                                                            </div>
                                                        </div>
                                                        <div style={styles.mediaFooter}>
                                                            <span>{getMediaInteractionHint(mediaDetails.mediaType)}</span>
                                                        </div>
                                                    </div>
                                                )}

                                                <div style={hasMediaInRow ? styles.captionSectionWithMedia : styles.captionSection}>
                                                    <div style={styles.sectionTitle}>Post Caption</div>
                                                    <div style={
                                                        expandedPosts[post.ContentId] 
                                                            ? (hasMediaInRow ? styles.contentBoxWithMedia : styles.contentBox)
                                                            : (hasMediaInRow ? styles.contentBoxTruncatedWithMedia : styles.contentBoxTruncated)
                                                    }>
                                                        {makeLinksClickable(post?.Content || 'No content available.')}
                                                    </div>
                                                    {post?.Content && (
                                                        <button style={styles.toggleLink} onClick={() => toggleContent(post.ContentId)}>
                                                            {expandedPosts[post.ContentId] ? 'Show Less' : 'Read More'}
                                                        </button>
                                                    )}
                                                </div>

                                                <div>
                                                    <div style={styles.sectionTitle}>Prompt</div>
                                                    <div style={styles.promptBox}>{post.Prompts ? post.Prompts : post.InterestsPromptData || 'No prompt provided.'}</div>
                                                </div>
                                            </div>

                                            <div className="mt-4" style={styles.actionsWrapper}>
                                                <ActionButton
                                                    icon={faTrash}
                                                    label="Delete"
                                                    variant="outline-danger"
                                                    tooltip="Delete this post"
                                                    onClick={() => handleDeactivateClick(post)}
                                                    loading={!!deactivating[post.ContentId]}
                                                />
                                                <ActionButton
                                                    icon={faComment}
                                                    label="Comments"
                                                    tooltip="View LinkedIn comments"
                                                    onClick={() => handleViewPostComments(post.LinkdinPostId)}
                                                    disabled={!post.LinkdinPostId}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                {filteredPosts.length > postsPerPage && (
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLinkClassName="page-link"
                    />
                )}

                <Modal show={showDeactivateModal} onHide={handleCloseDeactivateModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Deletion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to delete this post?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeactivateModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="danger"
                            onClick={handleConfirmDeactivate}
                            disabled={deactivating[postToDeactivate?.ContentId]}
                        >
                            {deactivating[postToDeactivate?.ContentId] ? 'Deleting...' : 'Delete'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showMediaModal} onHide={handleCloseMediaModal} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Media Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {renderModalMedia()}
                    </Modal.Body>
                </Modal>
            </div>
        </SideNavbar>
    );
};

export default ViewAllPostedPosts;
